<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124.72 73.85" alt="Qintro" class="main-logo" :width="size"><path d="M17,.15H0v73.7H22.68V68.18H17Zm-5.67,68H5.67V5.82h5.67Z" style="fill:#fff"/><path d="M107.72.15v73.7h17V.15Zm11.34,68h-5.67V5.82h5.67Z" style="fill:#fff"/><rect x="28.35" y="5.82" width="5.67" height="68.03" style="fill:#fff"/><polygon points="51.02 36.93 45.35 0 39.69 0 39.71 0.15 39.69 0.15 39.69 73.85 45.35 73.85 45.35 36.93 51.02 73.85 56.69 73.85 56.69 0.15 51.02 0.15 51.02 36.93" style="fill:#fff"/><polygon points="68.03 0.15 62.36 0.15 62.36 5.82 68.03 5.82 68.03 73.85 73.7 73.85 73.7 5.82 79.37 5.82 79.37 0.15 73.7 0.15 68.03 0.15" style="fill:#fff"/><path d="M90.71.15H85v73.7h5.67v-68h5.67v17a5.67,5.67,0,0,1-5.67,5.67v5.67a5.67,5.67,0,0,1,5.67,5.67v34h5.67v-34a11.32,11.32,0,0,0-3.86-8.51,11.28,11.28,0,0,0,3.86-8.5V.15H90.71Z" style="fill:#fff"/><rect x="22.68" id="accent" y="0.15" width="5.67" height="5.67" style="fill:#0f9"/></svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 100
    }
  }
}
</script>
